import { buildPrefixedKey } from "../dataGridUrlState/index.js";

/**
 * @param {string} urlStateKey
 * @returns {string}
 */
export function buildPresetParamKey(urlStateKey) {
  return buildPrefixedKey(urlStateKey, "preset");
}

/**
 * @param {URLSearchParams} searchParams
 * @param {string} urlStateKey
 * @returns {boolean}
 */
export function hasManualGridParams(searchParams, urlStateKey) {
  const prefix = `${urlStateKey}.`;
  const presetKey = buildPresetParamKey(urlStateKey);
  for (const key of searchParams.keys()) {
    if (key.startsWith(prefix) && key !== presetKey) {
      return true;
    }
  }
  return false;
}

/**
 * @param {URLSearchParams} searchParams
 * @param {string} urlStateKey
 * @returns {string|null}
 */
export function getPresetIdFromUrl(searchParams, urlStateKey) {
  return searchParams.get(buildPresetParamKey(urlStateKey));
}
